const ALLOWED_CHARS_CLASS = `0-9a-zA-ZąćęłńóśźżĄĆĘŁŃÓŚĆŻŹ @€\\$\\?\\}/\\\\\\{!<>\\]\\[\\-_\\+"':;\\.,\\)\\(&\\^%#=\\n`;

export const DISALLOWED_CHARS_REGEX = new RegExp(
  `[^${ALLOWED_CHARS_CLASS}]`,
  "g",
);

export const sanitizeValue = (
  rawValue: any,
): { cleaned: any; invalidChars: string[] } => {
  if (typeof rawValue !== "string") {
    return { cleaned: rawValue, invalidChars: [] };
  }

  const invalidChars = rawValue.match(DISALLOWED_CHARS_REGEX) ?? [];
  const cleaned = rawValue.replace(DISALLOWED_CHARS_REGEX, "");

  return { cleaned, invalidChars };
};
